import { merge } from 'lodash';
import { DEVELOPMENT, LOCAL, PRODUCTION } from '../contracts/constants/environments.constants';

import { base } from './env/base';
import { prod } from './env/prod';
import { dev } from './env/dev';
import { local } from './env/local';

let mergedConfig;

const release = process.env['NODE_ENV'] || PRODUCTION;
const isBrowser = typeof(window) != 'undefined';

switch (release) {
  case DEVELOPMENT:
    mergedConfig = merge({}, base, dev);
    break;
  case LOCAL:
    mergedConfig = merge({}, base, local);
    break;
  default:
    mergedConfig = merge({}, base, prod);
    break;
}

const env = { ...mergedConfig, isBrowser };

export { env };

